export default "__VITE_ASSET__b6595a04__"